/* global t */
// Help articles for tax return, annual accounts and the AI accountant. Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business so no customer data is exposed.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  taxReturn: { id: 'taxReturn', title: t('ha.taxReturn.title'), category: t('ha.cat.closing'), read: t('ha.read3'), route: 'skattemelding',
    keywords: t('ha.taxReturn.keywords'),
    lead: t('ha.taxReturn.lead'),
    blocks: [
    { t: 'tip', kind: 'warn', title: t('ha.taxReturn.external'), text: t('ha.taxReturn.externalText') },
    { t: 'step', n: 1, title: t('ha.taxReturn.draft'), text: t('ha.taxReturn.draftText') },
    { t: 'step', n: 2, title: t('ha.taxReturn.steps'), text: t('ha.taxReturn.stepsText') },
    { t: 'step', n: 3, title: t('ha.taxReturn.check'), text: t('ha.taxReturn.checkText') },
    { t: 'step', n: 4, title: t('ha.taxReturn.file'), text: t('ha.taxReturn.fileText') },
    { t: 'tip', kind: 'info', title: t('ha.taxReturn.entity'), text: t('ha.taxReturn.entityText') }]
  },
  annualAccounts: { id: 'annualAccounts', title: t('ha.annualAccounts.title'), category: t('ha.cat.closing'), read: t('ha.read3'), route: 'arsregnskap',
    keywords: t('ha.annualAccounts.keywords'),
    lead: t('ha.annualAccounts.lead'),
    blocks: [
    { t: 'heading', text: t('ha.h6.before') },
    { t: 'para', text: t('ha.annualAccounts.beforeText') },
    { t: 'step', n: 1, title: t('ha.annualAccounts.about'), text: t('ha.annualAccounts.aboutText') },
    { t: 'step', n: 2, title: t('ha.annualAccounts.figures'), text: t('ha.annualAccounts.figuresText') },
    { t: 'step', n: 3, title: t('ha.annualAccounts.notes'), text: t('ha.annualAccounts.notesText') },
    { t: 'step', n: 4, title: t('ha.annualAccounts.documents'), text: t('ha.annualAccounts.documentsText') },
    { t: 'step', n: 5, title: t('ha.annualAccounts.sign'), text: t('ha.annualAccounts.signText') },
    { t: 'step', n: 6, title: t('ha.annualAccounts.file'), text: t('ha.annualAccounts.fileText') },
    { t: 'tip', kind: 'info', title: t('ha.taxReturn.entity'), text: t('ha.annualAccounts.scopeText') }]
  },
  aiAccountant: { id: 'aiAccountant', title: t('ha.aiAccountant.title'), category: t('ha.cat.ai'), read: t('ha.read3'), route: 'aiautopilot',
    keywords: t('ha.aiAccountant.keywords'),
    lead: t('ha.aiAccountant.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.aiAccountant.agents'), text: t('ha.aiAccountant.agentsText') },
    { t: 'step', n: 2, title: t('ha.aiAccountant.bank'), text: t('ha.aiAccountant.bankText') },
    { t: 'step', n: 3, title: t('ha.aiAccountant.month'), text: t('ha.aiAccountant.monthText') },
    { t: 'step', n: 4, title: t('ha.aiAccountant.review'), text: t('ha.aiAccountant.reviewText') },
    { t: 'step', n: 5, title: t('ha.aiAccountant.post'), text: t('ha.aiAccountant.postText') },
    { t: 'tip', kind: 'info', title: t('ha.aiAccountant.control'), text: t('ha.aiAccountant.controlText') },
    { t: 'tip', kind: 'warn', title: t('ha.aiAccountant.filings'), text: t('ha.aiAccountant.filingsText') }]
  }
})]);
